import { render, staticRenderFns } from "./saAsideNavItem.vue?vue&type=template&id=50a9ef2a"
import script from "./saAsideNavItem.vue?vue&type=script&lang=js"
export * from "./saAsideNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports